module.exports = __webpack_public_path__ + "static/img/env17.6316ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env17.png
// module id = 110
// module chunks = 4